module.exports = __webpack_public_path__ + "img/ricelog_pinicon_021.326a5df4.png";